export class AuditSignIn {
        public activity_Id: number
        public activity_Type: number ;
        public activity_By:number ;
        public topTable: number;
        public effectedTableName:string;
        public effectedColumnName: string;
        public effectedTableID: string;
        public auditTableName: string;
        public auditColumnName:string;
        public auditTableID:string ;
        public activity_Desc:string ;
        public effectedQuery: string ;
        public auditQuery: string ;
        public moduleName: string ;
        public physician_Id: number;
        public staffId: number;
        public patient_Id: number;
        public visitId: number;
        public practiceID: number;
        public patientLocation:string;
        public systemIP:string;
        public publicIP:string;
        public startDate: string;
        public endDate: string;
        public reasonforUpdate:string ;
        public logONOff: boolean;
        public lonONOffDate: string;
        public logOnOffUser: string ;
        public enteredBy: number ;
        public activity_IdOut: number ;
        public LogId:number;
        public UserId:string;
        public LoginTime:string;
        public LoginSystemIP:string;
        public LoginRemoteIP:string;
        public Status:string ;
        public email:string;
        public encryptType:string;
}
